import axios from 'lib/axios'

export interface LuminaDescriptiveMapsRequest {
  mail: string
  type: 'lumina_descriptive_maps_request'
  company: string
  message?: string
  contact_name: string
  contact_email: string
  contact_phone: string
  internal_only: true
}

export interface LuminaIntegrationRequest {
  mail: string
  type: 'lumina_integration_request'
  company: string
  message?: string
  contact_name: string
  contact_email: string
  contact_phone: string
  internal_only: false
}

export const requestLuminaDescriptiveMapsInfo = async (payload: LuminaDescriptiveMapsRequest) => {
  const response = await axios.post('/email/send', [payload])
  return response.data
}

export const requestLuminaIntegrationInfo = async (payload: LuminaIntegrationRequest) => {
  const response = await axios.post('/email/send', [payload])
  return response.data
}

export interface LuminaMember {
  member_id: number
  user_id: number
  manager_member_id: number | null
  full_name: string
  document: string | null
  email: string | null
  cargo: string | null
  completed_tests?: string[]
}

export interface LuminaTeam {
  id: number
  name: string
  description: string
  member_count?: number
  members?: LuminaMember[]
}

export interface LuminaTeamPayload {
  name: string
  description: string
  member_ids: number[]
}

export interface LuminaTeamOrganizationPayload {
  relationships: Array<{ member_id: number; manager_member_id: number | null }>
}

export interface LuminaPerson {
  user_id: number
  full_name: string
  document: string | null
  email: string | null
  cargo: string | null
  completed_tests: string[]
  desempeno: number | null
}

export const getLuminaTeams = async (): Promise<LuminaTeam[]> => {
  const response = await axios.get('/lumina/teams')
  return response.data.data
}

export const getLuminaTeam = async (id: number): Promise<LuminaTeam> => {
  const response = await axios.get(`/lumina/teams/${id}`)
  return response.data.data
}

export const getEligibleLuminaMembers = async (search = ''): Promise<LuminaMember[]> => {
  const response = await axios.get('/lumina/teams/eligible-members', {
    params: search ? { search } : undefined,
  })
  return response.data.data
}

export const getLuminaPeople = async (search = ''): Promise<LuminaPerson[]> => {
  const response = await axios.get('/lumina/people', { params: search ? { search } : undefined })
  return response.data.data
}

export const updateLuminaPersonDesempeno = async (userId: number, desempeno: number | null): Promise<void> => {
  await axios.put(`/lumina/people/${userId}/desempeno`, { desempeno })
}

export const updateLuminaPersonCargo = async (userId: number, cargo: string): Promise<void> => {
  await axios.put(`/lumina/people/${userId}/cargo`, { cargo })
}

export const syncTeamWithLumina = async (teamId: number): Promise<any> => {
  const response = await axios.post(`/lumina/teams/${teamId}/lumina/sync`)
  return response.data
}

export const syncTeamWithNinebox = async (teamId: number): Promise<any> => {
  const response = await axios.post(`/lumina/teams/${teamId}/ninebox/sync`)
  return response.data
}

export const createLuminaTeam = async (payload: LuminaTeamPayload): Promise<LuminaTeam> => {
  const response = await axios.post('/lumina/teams', payload)
  return response.data.data
}

export const updateLuminaTeam = async (id: number, payload: LuminaTeamPayload): Promise<LuminaTeam> => {
  const response = await axios.put(`/lumina/teams/${id}`, payload)
  return response.data.data
}

export const deleteLuminaTeam = async (id: number): Promise<void> => {
  await axios.delete(`/lumina/teams/${id}`)
}

export const updateLuminaTeamOrganization = async (
  id: number,
  payload: LuminaTeamOrganizationPayload
): Promise<LuminaTeam> => {
  const response = await axios.put(`/lumina/teams/${id}/organization`, payload)
  return response.data.data
}
